import api from '../Axios'; 

export const feedbackAPI = {
  
  // 1. Submit a new review at the end of a session
  submitSessionFeedback: async (data: {
    sessionId: string;
    targetCode: string;
    rating: number;
    feedbackText: string;
    userCode: string;      
    reviewerName: string;  
  }) => {
    const response = await api.post('/api/feedback/submit', data);
    return response.data;
  },

  // 🟢 2. NEW: Fetch all reviews and stats for the Expert Profile Page
  getExpertReviews: async (expertCode: string) => {
    const response = await api.get(`/api/feedback/${expertCode}`);
    return response.data;
  }
  
};